module.exports = __webpack_public_path__ + "img/banner.58d2476b.png";